module.exports = __webpack_public_path__ + "static/exit-intent-71a6771d6c909096425a947d922105a2.jpg";